import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import App from './App'
import ElementUI from 'element-ui'
//import './element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'
//import 'element-ui/lib/theme-darkblue/index.css'
//import './assets/theme/theme-green/index.css'
//import './assets/theme/theme-darkblue/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
//xls
//import Mock from './mock'
//Mock.bootstrap();
//import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.component('downloadExcel', JsonExcel)

//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  //NProgress.start();
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js